import Header from './components/Header';
import HeroSection from './components/HeroSection';
import TopicsSection from './components/TopicsSection';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import FeaturesSection from './components/FeaturesSection';
import FaqSection from './components/FaqSection';
import CommentsSection from './components/CommentsSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import ContactSection from './components/ContactSection';
import UpdatesSection from './components/UpdatesSection';
import IndexSection from './components/IndexSection';
import CarouselSection from './components/CarouselSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />

      <main>
        <HeroSection />
        <TopicsSection />
        <AboutSection />
        <CardsSection />
        <RankingSection />
        <FeaturesSection />
        <FaqSection />
        <CommentsSection />
        <MediaSection />
        <AppSection />
        <ContactSection />
        <UpdatesSection />
        <IndexSection />
        <CarouselSection />
      </main>

      <Footer />
    </div>
  );
}